<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ADMINISTRAR SECTORES INSPECCIÓN PAC</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
            <v-card-text>
                <v-btn color="green" fab small dark @click="crear">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-card-text>
            <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
        </v-card>

        <data-table class="mt-5" @editar="editar($event)" @abrir_modal_items="ver_items($event)"></data-table>

        <modal @peticionrealizada="cargarDatos"></modal>

        <!-- modal items -->
        <v-dialog
            v-model="mostrar_items"
            width="80%"
        >
            <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="red lighten-2"
                dark
                v-bind="attrs"
                v-on="on"
                >
                Click Me
                </v-btn>
            </template> -->

            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Listado de Items Sector {{sector_actual?sector_actual.nombre:''}}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="9">
                            <v-btn color="green" fab small dark @click="crear_item">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="buscar_item"
                                append-icon="mdi-magnify"
                                label="Buscar..."
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    
                </v-card-text>
                <v-card-text>
                    <v-data-table
                        :headers="cabeceras_items"
                        :items="items_modal"
                        :search="buscar_item"
                    >
                        <template v-slot:item.action="{ item }">
                            <v-btn color="orange darken-3" fab small dark class="mr-2" @click="editar_item(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="mostrar_items = false"
                >
                    Cerrar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre*',key:'nombre'},
            {tipo:'texto',valor:'0',label:'Orden*',key:'orden'},
            {tipo:'switch',valor:1,label:'Activo*',key:'activo'},
        ],
        inputs_item:[
            {tipo:'texto',valor:'',label:'Nombre*',key:'nombre'},
            {tipo:'texto',valor:'0',label:'Orden*',key:'orden'},
            {tipo:'switch',valor:1,label:'Activo*',key:'activo'},
            {tipo:'hidden',valor:'',label:'Sector Inspección*',key:'pac_sectores_inspecciones_id'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
            {
                text: 'Nombre',
                align: 'center',
                sortable: true,
                value: 'nombre',
                class:'cabecera'
            },
            {
                text: 'Orden',
                align: 'center',
                sortable: true,
                value: 'orden',
                class:'cabecera'
            },
            {
                text: 'Activo',
                align: 'center',
                sortable: true,
                value: 'activo_texto',
                class:'cabecera',
            },
            {
                text: 'Items',
                align: 'center',
                sortable: true,
                value: 'items',
                class:'cabecera',
            },
            { text: 'Acciones', value: 'action', sortable: false, align:'center', class:'cabecera' },
        ],
        cabeceras_items:[
            {
                text: 'Nombre',
                align: 'center',
                sortable: true,
                value: 'nombre',
            },
            {
                text: 'Orden',
                align: 'center',
                sortable: true,
                value: 'orden',
            },
            {
                text: 'Activo',
                align: 'center',
                sortable: true,
                value: 'activo_texto',
            },
            { text: 'Acciones', value: 'action', sortable: false, align:'center' },
        ],
        acciones:[
            {key:'editar',titulo:'Editar',visible:true}
        ],
        sector_actual:null,
        items_modal:[],
        mostrar_items:false,
        buscar_item:''
    }),
    mounted() {
        this.cargarDatos();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Administrar Sectores Inspección PAC`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran los sectores en donde se hacen las inspecciones PAC.`},
                {   tipo:`label`,   texto:`- Se puede añadir un nuevo sector con el botón "+" y rellenando cada campo requerido (Nombre, Orden, Activo)`},
                {   tipo:`label`,   texto:`- En la tabla, en la columna items, al pulsar el botón de un sector, se muestra un listado con cada item de ese sector y se indica su orden, si están activos y la opción para modificarlos, además de poder agregar uno nuevo con el botón "+"`},
                {   tipo:`label`,   texto:`- En la tabla, en la columna acciones, al pulsar el botón de un sector, se muestra una ventana con los campos de ese sector para poder modificarlos. Al finalizar de la edición, se debe pulsar en "Actualizar"`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}pac_sector_inspeccion`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                
                if(this.sector_actual){
                    let index = this.lista.findIndex(i => i.id == this.sector_actual.id);
                    this.items_modal = this.lista[index].items;
                }
                
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Sector Inspección';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'pac_sector_inspeccion';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Sector Inspección';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `pac_sector_inspeccion/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        async editar_item(item){
            let index = this.sector_actual.items.findIndex(i=>i.id == item.id);
            console.log('index',index);
            await this.inputs_item.forEach(input => {
                //recorrido del objeto a editar
                Object.keys(item).forEach(key => {
                    let valor = item[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            this.configuracion_modal.titulo_modal = 'Editar Item';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `pac_item_sector/${item.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs_item,this.configuracion_modal);
        },

        crear_item(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Item';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'pac_item_sector';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.inputs_item[1].valor = 1;
            this.inputs_item[3].valor = this.sector_actual.id;
            this.$emit('abrir',this.inputs_item,this.configuracion_modal);
        },

        ver_items($event){
            this.sector_actual = $event;
            this.items_modal = $event.items;
            this.mostrar_items = true;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
